/**
 * Plain-text rendering of a resolved cell — the single source of truth for what
 * a cell "says", shared by the grid (ExplorerCell) and export so they never
 * diverge. Returns a display string (no React).
 */
import { formatCellValue, formatMetaValue } from './value-format'
import { RECORD_STATUS_LABELS, SUBMISSION_STATUS_LABELS } from '../types/data-view-spec'
import type { ResolvedColumn, ResolvedRow } from './spec-resolver'

export function cellText(column: ResolvedColumn, row: ResolvedRow): string {
  if (column.id in row.display) return row.display[column.id]

  if (column.kind === 'meta') {
    const key = column.metaKey!
    const val = row.cells[column.id]
    if (key === 'record_status') return RECORD_STATUS_LABELS[String(val)] ?? String(val ?? '—')
    if (key === 'submission_status') return val ? (SUBMISSION_STATUS_LABELS[String(val)] ?? String(val)) : '—'
    if (key === 'soft_warning_count') return String(Number(val ?? 0))
    return formatMetaValue(key, val)
  }
  return formatCellValue(column.catalogField, row.cells[column.id])
}
